import React from 'react';
import Modal from 'react-bootstrap/Modal';
import classnames from 'classnames';
import {Trans} from 'react-i18next';
import {history} from '../../../../utils/redux/store';

const ClickDisabledPopup = ({
  showUpgradeDialog,
  setShowUpgradeDialog,
  isEnterprise = false,
  type = 'SKIN_ANALYSIS', //AESTHETIC_SIMULATION
}) => {
  const modalDesc = isEnterprise ? (
    <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.modal.advanced.feature.desc2">
      This advanced concern isn’t supported for your plan. Please contact us to
      upgrade your plan.
    </Trans>
  ) : (
    <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.modal.advanced.feature.desc">
      This advanced concern is only for Premium accounts. Please upgrade your
      plan.
    </Trans>
  );

  const modalBtn = isEnterprise ? (
    <button
      className={classnames({
        btn: true,
        'btn btn-brand': true,
      })}
      onClick={() => {
        history.push('/contactus/add-request');
      }}
    >
      <Trans i18nKey="p.contactus.title">Contact Us</Trans>
    </button>
  ) : (
    <button
      className={classnames({
        btn: true,
        'btn btn-danger': true,
      })}
      onClick={() => {
        history.push(`/plan-pricing/change-plan/type=${type}`);
      }}
    >
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.modal.button">
        Upgrade
      </Trans>
    </button>
  );

  return (
    <Modal
      id="category_upgrade_dialog"
      show={showUpgradeDialog}
      onHide={() => setShowUpgradeDialog(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.modal.advanced.feature">
            Advanced Feature
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{fontSize: '16px'}}>{modalDesc}</div>
      </Modal.Body>
      <Modal.Footer>{modalBtn}</Modal.Footer>
    </Modal>
  );
};

export default ClickDisabledPopup;
